module.exports = __webpack_public_path__ + "static/media/icon-nosso.54d9f431.svg";